import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { CategoryFirstLevel } from '@/shared/dtos/category-first-level';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'CategoryFirstLevelModule',
    store,
    dynamic: true,
})

class CategoryFirstLevelModule extends VuexModule implements BaseModule {
    public categories: CategoryFirstLevel[] = [];

    @Mutation
    public resetState(): void {
        this.categories = [];
    }



    @Action
    public async getCategoriesFirstLevel() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.categoryFirstLevel);
        this.context.commit('updateCategoriesFirstLevel', res);
    }

    @Action
    public async getCategoriesAnonymous(){
        const res = await itiHttpService.get(API.categoriesFirstLevelAnonymous, false, false, false);
        this.context.commit('updateCategoriesFirstLevel', res);
    }

    @Mutation
    public updateCategoriesFirstLevel(items: CategoryFirstLevel[]) {
        this.categories = items.map(x => new CategoryFirstLevel(x));
    }

    @Action
    public async insertarCategoryFirstLevel(item: CategoryFirstLevel) {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.post(API.categoryFirstLevel, item, false);
        this.context.dispatch('getCategoriesFirstLevel');
    }

    @Action
    public async modificarCategoryFirstLevel(item: CategoryFirstLevel) {
        if (!itiTokenService.hasToken()) { return; }
        try {
            const res = await itiHttpService.put(API.categoryFirstLevel, item, false);
        } catch {
            // ...
        }
        this.context.dispatch('getCategoriesFirstLevel');
    }

    @Action
    public async eliminarCategoryFirstLevel(id: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteCategory = ItiString.Format(API.categoryFirstLevelDetail, id);
        const res = await itiHttpService.delete(apiDeleteCategory, id, false);
        this.context.dispatch('getCategoriesFirstLevel');
    }

    @Action
    public async syncCategories(){
        try {
            const url = API.categoryFirstLevel + '/UpdateCategories';
            const response = await itiHttpService.get(url, null, true, false, false);
        } catch (err) {
            // ...
        }
    }
}

export default getModule(CategoryFirstLevelModule);